import { Loader } from "@circle-react-uikit/Loader";
import { useUpgradePlanContext } from "./../UpgradePlanContext";
import { DowngradeIntervalDetails } from "./DowngradeIntervalDetails";
import { DowngradePlanDetails } from "./DowngradePlanDetails";
import { UpgradeIntervalDetails } from "./UpgradeIntervalDetails";
import { UpgradePlanDetails } from "./UpgradePlanDetails";

interface PlanDetailsProps {
  subheading?: string;
  hideModal: () => void;
  onSubmitHandler: () => void;
}

export const PlanDetails = ({
  subheading = "",
  hideModal,
  onSubmitHandler,
}: PlanDetailsProps) => {
  const { plan, isPlanLoading } = useUpgradePlanContext();

  if (isPlanLoading) {
    return <Loader />;
  }

  const componentMap: Record<string, React.ComponentType<PlanDetailsProps>> = {
    interval_upgrade: UpgradeIntervalDetails,
    interval_downgrade: DowngradeIntervalDetails,
    downgrade: DowngradePlanDetails,
    upgrade: UpgradePlanDetails,
  };

  const Component = plan?.plan_action
    ? componentMap[plan.plan_action]
    : UpgradePlanDetails;

  return (
    <Component
      subheading={subheading}
      hideModal={hideModal}
      onSubmitHandler={onSubmitHandler}
    />
  );
};
